import type { FilesStorageSchema } from '@iconik-io/iconik-api/src/services/files';

export type StorageMethod = FilesStorageSchema['method'];

export const CLOUD_STORAGE_METHODS: StorageMethod[] = [
  'S3',
  'GCS',
  'B2',
  'AZURE',
];

const cloudStorageMethods = new Set<string>(CLOUD_STORAGE_METHODS);

/** Storage methods arrive as plain strings on API payloads. */
export const isCloudStorageMethod = (method: string): boolean =>
  cloudStorageMethods.has(method);
